module.exports = __webpack_public_path__ + "img/fi-rr-box-alt.335e7060.svg";